
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 15 21.85\" id=\"share\" ><title>share</title><path d=\"M15 21.85H0v-14h5v1.31H1.36v11.33h12.28V9.16H10V7.85h5zm-6.82-7H6.82V2.6L4.56 4.86l-1-1L7.5 0l3.9 3.9-1 1-2.22-2.3z\" data-name=\"Layer 2\"/></symbol>";
module.exports = sprite.add(image, "share");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/share.svg
// module id = 665
// module chunks = 1474